import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import * as Layout from 'secured/components/layout';

class SecuredLayout extends PureComponent {
  static propTypes = {
    company: PropTypes.object,
    permissions: PropTypes.object,
    subcompany: PropTypes.object,
    menu: PropTypes.object,
    subcompanies: PropTypes.array,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
    }),
    toggleMenu: PropTypes.func,
  };
  state = {
    leftOpen: false,
    rightOpen: false,
    wZidth: window.innerWidth,
    height: window.innerHeight,
    isMobile: false,
  };
  componentDidMount = (props) => {
    this.useWindowSize();
  };
  componentDidUpdate = () => {};
  componentWillUnmount = () => {};
  useWindowSize() {
    const handleResize = () => {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth <= 675,
      });
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }

  toggleSidebar = (event) => {
    let key = `${event.currentTarget.parentNode.id}Open`;
    this.setState({ [key]: !this.state[key] });
  };
  render = () => {
    let leftOpen = this.state.leftOpen ? 'open' : 'closed';
    let rightOpen = this.state.rightOpen ? 'open' : 'closed';
    const isMobile = this.state.isMobile;
    if (!isMobile) {
      return (
        <Fragment>
          <Layout.Navbar
            company={this.props.company}
            subcompany={this.props.subcompany}
            subcompanies={this.props.subcompanies}
            user={this.props.user}
          />
          {this.props.company && (
            <Layout.SideMenu
              company={this.props.company}
              subcompany={this.props.subcompany}
              permissions={this.props.permissions}
              menu={this.props.menu}
              toggleMenu={this.props.toggleMenu}
            />
          )}
          <div
            className={classnames('container-fluid', 'bg-default', 'auth-container', {
              'with-menu': this.props.company,
            })}
          >
            {this.props.children}
          </div>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Layout.Navbar
            company={this.props.company}
            subcompany={this.props.subcompany}
            subcompanies={this.props.subcompanies}
            user={this.props.user}
          />
          <div id="layout">
            <div id="left" className={leftOpen}>
              <div className="icon" onClick={this.toggleSidebar}>
                &equiv;
              </div>
              <div className={`sidebar ${leftOpen}`}>
                <div className="header" onClick={this.toggleSidebar}>
                  {/* <h3 className="title">Side Menu</h3> */}
                </div>
                <div className="content">
                  <div className="backMenu"></div>
                  {this.props.company && (
                    <Layout.SideMenu
                      isMobile={isMobile}
                      company={this.props.company}
                      subcompany={this.props.subcompany}
                      permissions={this.props.permissions}
                      menu={this.props.menu}
                      toggleMenu={this.props.toggleMenu}
                    />
                  )}
                </div>
              </div>
            </div>

            <div id="main">
              <div className="header">
                <h3
                  className={`
                      title
                      ${'left-' + leftOpen}
                      ${'right-' + rightOpen}
                  `}
                ></h3>
              </div>
              <div className="content">
                <div
                  className={classnames('container-fluid', 'bg-default', 'auth-container', {
                    'with-menu': this.props.company,
                  })}
                >
                  {this.props.children}
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    }
  };
}

export default SecuredLayout;



// WEBPACK FOOTER //
// src/modules/secured/components/SecuredLayout.js